import clsx from 'clsx';

/**
 * Utility for merging class names conditionally
 * @param {...(string|undefined|null|false|Record<string, boolean>)} inputs - Class names to merge
 * @returns {string} Merged class names
 */
export function cn(...inputs) {
  return clsx(inputs);
}
